import { FC } from "react";

export type ScrollProgressPropsType = {
  progress: number;
};

const ScrollProgress: FC<ScrollProgressPropsType> = ({ progress }) => {
  return (
    <div className="progress-bar fixed top-0 w-full z-50  bg-gray-700 shadow-lg">
      <div
        className="progress bg-white h-1"
        style={{
          transformOrigin: "left",
          willChange: "transform",
          transform: `scaleX(${progress / 100})`,
        }}
      ></div>
    </div>
  );
};

export default ScrollProgress;
